import { render, staticRenderFns } from "./SensitiveEnglish.vue?vue&type=template&id=08c0bf5b&"
import script from "./SensitiveEnglish.vue?vue&type=script&lang=js&"
export * from "./SensitiveEnglish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports